import { useRequest } from 'features/request/useRequest';

import { useMemo } from 'react';

import { WorkOrderChangeStatusProps } from '../../../../../../constantsProject';
import { WorkOrderChangeStatusEnum } from '../../../../../../gql/graphql';
import { getLabelWorkOrder } from '../../../../../../utils/getLabelWorkOrder';
import { uerClosingWorkOrderChangeDefaultsGql } from '../../WorkOrderChangeQueries';

interface IUseUerClosingWorkOrderChangeDefaults {
    workOrderId: number;
    onError: () => void;
}

const requestId = 'uerClosingWorkOrderChangeDefaults';

export const useUerClosingWorkOrderChangeDefaults = (props: IUseUerClosingWorkOrderChangeDefaults) => {
    const { workOrderId, onError } = props;

    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [uerClosingWorkOrderChangeDefaultsData, uerClosingWorkOrderChangeDefaultsStatus] = useRequest({
        requestId,
        query: uerClosingWorkOrderChangeDefaultsGql,
        variables,
        onErrorUpdater: onError,
    });

    const uerClosingWorkOrderChangeDefaultsDataItem = useMemo(() => {
        const data = uerClosingWorkOrderChangeDefaultsData?.uerClosingWorkOrderChangeDefaults?.data;

        return !data
            ? data
            : {
                  ...data,
                  status: WorkOrderChangeStatusProps[WorkOrderChangeStatusEnum.Approved],
                  workOrder: getLabelWorkOrder({
                      internalNumber: data.workOrderNumberText,
                      signingDate: data.workOrderSigningDate,
                  }),
                  updatedAt: data.updatedAt && new Date(data.updatedAt),
              };
    }, [uerClosingWorkOrderChangeDefaultsData?.uerClosingWorkOrderChangeDefaults?.data]);

    return { uerClosingWorkOrderChangeDefaultsDataItem, uerClosingWorkOrderChangeDefaultsStatus };
};
